'use strict';

/**
 * static helper module
 */
require(['vue', 'staticHelperApp'], function (Vue, staticHelperApp) {
  /* eslint no-new: "off" */
  Vue.config.productionTip = false;
  // 实例化vue
  new Vue({
    el: '#app',
    template: '<staticHelperApp/>',
    components: {
      staticHelperApp: staticHelperApp
    }
  });
});
define("Magento_Cms/modules/static_helper", function(){});

